<app-header></app-header>

<div class="content-area">
  <div class="container-fluid">

    <div class="d-flex justify-content-between align-items-center mb-4">
      <h3 class="mb-0">Ativos Cadastrados</h3>
      <button class="btn btn-primary fw-bold" (click)="irParaCadastro()">
        <i class="bi bi-plus-circle me-2"></i>Adicionar Novo Ativo
      </button>
    </div>

    <div class="card shadow-sm border-0 mb-4">
      <div class="card-body">
        <div class="row g-3 align-items-end">

          <!-- RESPONSÁVEL (substituiu o Pesquisar) -->
          <div class="col-lg-4 col-md-12">
            <label for="filterResponsavel" class="form-label fw-bold">Responsável</label>
            <input
              type="text"
              class="form-control"
              id="filterResponsavel"
              placeholder="Nome do responsável..."
              [(ngModel)]="filtros.nomeUsuario"
              (keyup.enter)="aplicarFiltros()">
          </div>

          <!-- CATEGORIA com dropdown + busca -->
          <div class="col-lg-3 col-md-6">
            <label class="form-label fw-bold">Categoria</label>
            <div class="position-relative">
              <div
                class="form-control d-flex justify-content-between align-items-center"
                style="cursor: pointer;"
                (click)="toggleDropdownCategoria()">
                <span [class.text-muted]="!filtros.categoriaId">{{ categoriaTexto }}</span>
                <i class="bi" [ngClass]="dropdownCategoriaAberto ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
              </div>

              <div
                *ngIf="dropdownCategoriaAberto"
                class="position-absolute w-100 bg-white border rounded shadow-sm"
                style="z-index: 1000; top: 100%; left: 0;">
                <div class="p-2 border-bottom">
                  <input
                    type="text"
                    class="form-control form-control-sm"
                    placeholder="Buscar categoria..."
                    [(ngModel)]="buscaCategoria"
                    (ngModelChange)="filtrarCategorias()"
                    (click)="$event.stopPropagation()">
                </div>
                <ul class="list-unstyled mb-0" style="max-height: 200px; overflow-y: auto;">
                  <li
                    class="px-3 py-2 dropdown-item"
                    [class.active]="filtros.categoriaId === null"
                    style="cursor: pointer;"
                    (click)="selecionarCategoria(null, 'Todas')">
                    Todas
                  </li>
                  <li
                    *ngFor="let cat of categoriasFiltradas"
                    class="px-3 py-2 dropdown-item"
                    [class.active]="filtros.categoriaId === cat.id"
                    style="cursor: pointer;"
                    (click)="selecionarCategoria(cat.id, cat.nome)">
                    {{ cat.nome }}
                  </li>
                  <li *ngIf="categoriasFiltradas.length === 0" class="px-3 py-2 text-muted small">
                    Nenhuma categoria encontrada
                  </li>
                </ul>
              </div>
            </div>
          </div>

          <!-- FILTROS AVANÇADOS -->
          <div class="col-lg-3 col-md-6">
            <label class="form-label fw-bold d-block">Filtros Avançados</label>
            <button
              class="btn btn-outline-secondary w-100"
              (click)="toggleFiltrosAvancados()">
              <i class="bi bi-funnel me-2"></i>
              {{ mostrarFiltrosAvancados ? 'Ocultar' : 'Mais Filtros' }}
              <i class="bi ms-2" [ngClass]="mostrarFiltrosAvancados ? 'bi-chevron-up' : 'bi-chevron-down'"></i>
            </button>
          </div>

          <!-- BOTÕES AÇÃO -->
          <div class="col-lg-2 col-md-12 d-flex gap-2">
            <button
              class="btn btn-primary flex-fill"
              (click)="aplicarFiltros()"
              title="Aplicar Filtros">
              <i class="bi bi-search"></i>
            </button>
            <button
              class="btn btn-secondary flex-fill"
              (click)="limparFiltros()"
              title="Limpar Filtros">
              <i class="bi bi-x-circle"></i>
            </button>
          </div>
        </div>

        <!-- FILTROS AVANÇADOS (sem o Responsável, que subiu pra cima) -->
        <div *ngIf="mostrarFiltrosAvancados" class="row g-3 mt-2 pt-3 border-top">

          <div class="col-lg-4 col-md-6">
            <label for="filterMarca" class="form-label fw-bold">Marca</label>
            <input
              type="text"
              class="form-control"
              id="filterMarca"
              placeholder="Digite a marca..."
              [(ngModel)]="filtros.marcaNome">
          </div>

          <div class="col-lg-4 col-md-6">
            <label for="filterModelo" class="form-label fw-bold">Modelo</label>
            <input
              type="text"
              class="form-control"
              id="filterModelo"
              placeholder="Digite o modelo..."
              [(ngModel)]="filtros.modeloNome">
          </div>

          <div class="col-lg-4 col-md-6">
            <label for="filterStatus" class="form-label fw-bold">Status</label>
            <select
              id="filterStatus"
              class="form-select"
              [(ngModel)]="filtros.statusAtivo">
              <option [ngValue]="null">Todos</option>
              <option [ngValue]="true">Ativo</option>
              <option [ngValue]="false">Baixado</option>
            </select>
          </div>

        </div>
      </div>
    </div>

    <div class="card shadow-sm border-0">
      <div class="card-body">

        <div *ngIf="carregando" class="text-center py-5">
          <div class="spinner-border text-primary" role="status">
            <span class="visually-hidden">Carregando...</span>
          </div>
        </div>

        <div *ngIf="!carregando">
          <div *ngIf="bensFiltrados.length === 0" class="text-center py-5 text-muted">
            <i class="bi bi-inbox display-1"></i>
            <p class="mt-3">Nenhum ativo encontrado com os filtros aplicados.</p>
          </div>

          <table *ngIf="bensFiltrados.length > 0" class="table table-hover align-middle">
            <thead class="table-light">
              <tr>
                <th>ID do Patrimônio</th>
                <th>Nome</th>
                <th>Categoria</th>
                <th>Marca</th>
                <th>Modelo</th>
                <th>Responsável</th>
                <th>Status</th>
                <th>Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let bem of bensFiltrados">
                <td><strong>#0{{ bem.exbePatrimonioId }}</strong></td>
                <td>{{ bem.descricao }}</td>
                <td>{{ bem.categoria?.nome || '-' }}</td>
                <td>{{ (bem.marca?.nome || '-') | uppercase }}</td>
                <td>{{ (bem.modelo?.nome || '-') | titlecase }}</td>
                <td>{{ bem.usuario?.usuarioCadastro || '-' }}</td>
                <td>
                  <span
                    class="badge rounded-pill"
                    [ngClass]="getStatusBadge(bem).class">
                    {{ getStatusBadge(bem).text }}
                  </span>
                </td>
                <td>
                  <button
                    class="btn btn-sm btn-outline-secondary me-1"
                    title="Ver Detalhes">
                    <i class="bi bi-eye"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-primary me-1"
                    [disabled]="!bem.ativo"
                    title="Editar">
                    <i class="bi bi-pencil"></i>
                  </button>
                  <button
                    class="btn btn-sm btn-outline-info"
                    [disabled]="!bem.ativo"
                    title="Movimentar">
                    <i class="bi bi-arrows-move"></i>
                  </button>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

  </div>
</div>